// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '@/router'
import '@/utils/rem'
import {Button} from 'vant';
import { Collapse, CollapseItem, Tabbar, TabbarItem, Toast, Swipe, SwipeItem, Lazyload, Divider, Icon, Tab, Tabs, Dialog, Popup, Picker, List, Cell, CellGroup, Search,CountDown} from 'vant';
import VueCupUi from 'vue-cup-ui';
import 'vue-cup-ui/lib/vue-cup-ui.css';

Vue.use(VueCupUi);

Vue.use(Button);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Divider);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Dialog);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(List);
Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Search)
Vue.use(CountDown)
/* eslint-disable no-new */
const app = new Vue({
  ...App,
  router,
})
.$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js